import { createSlice } from "@reduxjs/toolkit";

export enum CREATE_TYPE {
  EXISTING_REPO = "EXISTING_REPO",
}

export const projectsSlice = createSlice({
  name: "projects",
  initialState: {
    deleteProjectCandidateId: null,
    showDeleteProjectModal: false,
    showAddEditProjectModal: false,

    // Options for the add edit project modal
    editProjectCandidateId: null,
    createType: null,
    initialTab: "settings",
  },
  reducers: {
    // Toggle Modals
    setShowDeleteProjectModal: (state, action) => {
      state.showDeleteProjectModal = action.payload;
    },
    setShowAddEditProjectModal: (state, action) => {
      state.showAddEditProjectModal = action.payload;
    },

    // Set Candidate IDs
    setDeleteProjectCandidateId: (state, action) => {
      state.deleteProjectCandidateId = action.payload;
    },
    setEditProjectCandidateId: (state, action) => {
      state.editProjectCandidateId = action.payload;
    },
    setCreateType: (state, action) => {
      state.createType = action.payload;
    },
    setInitialTab: (state, action) => {
      state.initialTab = action.payload;
    },
  },
});

export const {
  setShowDeleteProjectModal,
  setShowAddEditProjectModal,
  setDeleteProjectCandidateId,
  setEditProjectCandidateId,
  setCreateType,
  setInitialTab,
} = projectsSlice.actions;

export default projectsSlice.reducer;
